import React from 'react';
import PropTypes from 'prop-types';
import Config from '../Config';

const config = new Config();

const FuturesIraDisclaimer = (props) => {
  const {
    page,
    iraHasOnlyFutures,
  } = props;
  const paragraphClass = page === 'summary' ? 'futuresIraMessageBoxSummaryPage' : 'futuresIraMessageBox';
  const imgClass = page === 'summary' ? 'futuresIraInfoIconSummaryPage' : 'futuresIraInfoIcon';
  const onlyFuturesStyle = iraHasOnlyFutures ? 'iraOnlyFuturesStyle' : '';

  if (page === 'funding') {
    return (
      <p className={`${paragraphClass} futuresFundingMessageBox`} style={{ display: 'flex', alignItems: 'flex-start' }}>
        <img
          className={`img-responsive ${imgClass} futuresFundingMessageBoxIcon`}
          src="images/info-icon.png"
          alt="Information Icon"
          style={{ flexShrink: 0 }}
        />
        {!config.rollover401kEnabled &&
          <span>
            To complete the setup of your Futures IRA account(s), you will need to ensure you have completed
            the application process with the custodian, Midland Trust. If you have not yet done so, please complete
            the application process by clicking below.
          </span>
        }
        {config.rollover401kEnabled &&
          <span>
            To complete the setup of your Futures IRA account, you will need to complete a separate account
            application with the custodian, Equity Trust. If you have done so, please complete the application
            process by clicking below. Once approved, all funding for your Futures IRA account must be deposited
            directly with Equity Trust.
          </span>
        }
      </p>
    );
  }
  return (
    <p className={`${paragraphClass} ${onlyFuturesStyle}`}>
      <img className={`img-responsive ${imgClass}`} src="images/info-icon.png" alt="Information Icon" />
      Beneficiary Selection for Futures &amp; Futures Options IRA accounts is available via the Custodian
      ({config.rollover401kEnabled ? 'Equity' : 'Midland'} Trust) and can only be selected after you
      complete this application and your account is approved.
    </p>
  );
};

FuturesIraDisclaimer.propTypes = {
    page: PropTypes.string,
    iraHasOnlyFutures: PropTypes.bool,
  };

export default FuturesIraDisclaimer;
